import { ServiceProviderPreferenceType } from 'Generated/graphql';
import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days2';
import Holidays from 'date-holidays';

// TODO: fix this to support holidays outside of the America/Winnipeg timezone
const hd = new Holidays('CA', 'MB');

const holidays = hd.getHolidays(
  new Date().getFullYear(),
).filter(
  h => h.type !== 'optional' && h.type !== 'observance'
).map(h => h.date.split(' ')[0]);
const options = {
  holidays,
  holidayFormat: 'YYYY-MM-DD',
};
dayjs.extend(dayjsBusinessDays, options);

type pref = {
  type: ServiceProviderPreferenceType;
  value: string;
}

export const getIsDefaultDropoffDeltaBusinessDays = <T extends pref>(
  prefs: T[],
) => {
  if (!prefs) {
    return true;
  }

  const dropoffDeltaIsBusinessDaysRaw = prefs.find(
    p => p.type === ServiceProviderPreferenceType.ServiceProviderPreferenceTypeIsDefaultDropoffDeltaBusinessDays
  )?.value;
  const dropoffDeltaIsBusinessDays = dropoffDeltaIsBusinessDaysRaw ?
    dropoffDeltaIsBusinessDaysRaw !== 'false' :
    true;

  return dropoffDeltaIsBusinessDays;
};

export const getDropoffDeltaDays = <T extends pref>(
  now: dayjs.Dayjs,
  prefs: T[],
) => {
  const defaultDropoffDeltaDays = 3;
  if (!prefs) {
    return defaultDropoffDeltaDays;
  }

  if (!now || !now.isValid()) {
    return defaultDropoffDeltaDays;
  }

  const dropoffDeltaDaysRaw = prefs.find(
    p => p.type === ServiceProviderPreferenceType.ServiceProviderPreferenceTypeDefaultDropoffDeltaDays
  )?.value;

  const dropoffDeltaDays = dropoffDeltaDaysRaw ?
    Math.round(parseFloat(dropoffDeltaDaysRaw)) :
    defaultDropoffDeltaDays;

  if (isNaN(dropoffDeltaDays) || dropoffDeltaDays <= 0) {
    return defaultDropoffDeltaDays;
  }

  const dropoffDeltaIsBusinessDays =
    getIsDefaultDropoffDeltaBusinessDays(prefs);

  if (dropoffDeltaIsBusinessDays) {
    const diff = now.clone().businessDaysAdd(dropoffDeltaDays).diff(now, 'day');
    return diff;
  }

  return dropoffDeltaDays;
};

export const calculateDropoffDeltaDays = (
  now: dayjs.Dayjs,
  delta: number,
  isBusinessDays: boolean,
) => {
  if (isBusinessDays) {
    const diff = now.clone().businessDaysAdd(delta).diff(now, 'day');
    return diff;
  }

  return delta;
};

export const getDropoffDefaultClockTime = <T extends pref>(
  prefs: T[],
) => {
  const fallbackDefaultTime = '9:00 am';
  if (!prefs) {
    return fallbackDefaultTime;
  }

  const dropoffClockTime = prefs.find(
    p => p.type === ServiceProviderPreferenceType.ServiceProviderPreferenceTypeDefaultDropoffClockTime
  )?.value;
  if (dropoffClockTime) {
    return dropoffClockTime;
  }

  return fallbackDefaultTime;
};
